import styled from 'styled-components';
import { rgba } from 'polished';

import * as Colors from '../../../../attrs/colors';
import MQ from '../../../../attrs/mq';

export const Container = styled.div`
  background: ${Colors.GREY_90};
  padding: 1rem;

  ${MQ.sm`
    padding: 2rem;
    margin: 0 -2rem;
  `}

  ${MQ.md`
    padding: 3rem;
    margin: 0 -3rem;
  `}
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 1.8rem;
  margin-bottom: 1rem;
`;

export const Body = styled.div``;

export const Footer = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;

  ${MQ.sm`
    padding-top: 3rem;
    padding-bottom: 0;
  `}
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ListItem = styled.li`
  margin: 1rem 0;

  .anticon {
    margin-right: 0.5rem;
  }
`;

export const Link = styled.a`
  font-weight: bold;
  border-bottom: 2px solid ${rgba(Colors.BLACK, 0.4)};
  padding: 0.5rem 0;
  transition: border 0.2s;

  :hover {
    border-bottom-color: ${Colors.BLACK};
    color: ${Colors.BLACK};
  }
`;
